//

// vendor modules
import { connect } from "react-redux"

// shared modules
import {
    fetchSearchData,
    registerPermanentFilters,
    resetFilters,
    storeLastLoadedUserUpdate,
} from "shared/search/action-creators"

// internal modules
import ListView from "shared/search/components/ListView/index"

import * as selectors from "shared/search/selectors"
import { selectIsBulkActionsSubmittable } from "shared/search/searchify/bulkactions/selectors"
import { selectSearchifyQuerysetList, selectIsSearchifySubmittable } from "shared/search/searchify/selectors"
import { toggleSearchifySelectedStatus } from "shared/search/searchify/action-creators"
import { selectLastResourceUpdateTimestamp } from "shared/api-caching/selectors"

const mapStateToProps = (state, props) => ({
    currentPage: selectors.selectCurrentPage(state, props),
    currentCount: selectors.selectCurrentCount(state, props),
    currentData: selectors.selectCurrentData(state, props),
    currentFilters: selectors.selectCurrentFilters(state, props),
    // loading logic
    isLoading: selectors.selectIsLoading(state, props),
    isLoadingMore: selectors.selectIsLoadingMoreData(state, props),
    loadingDataError: selectors.selectLoadingDataError(state, props),
    hasNewFiltersOnInitialLoad: selectors.selectHasNewFiltersOnInitialLoad(state, props),
    lastLoadedUserUpdate: selectors.selectLastLoadedUserUpdate(state, props),
    // filter logic (for no state)
    allDefaultFiltersActive: selectors.selectAreAllDefaultFiltersActive(state, props),
    nonDefaultFiltersActive: selectors.selectAreNonDefaultFiltersActive(state, props),
    // searchify
    searchifyQuerysets: selectSearchifyQuerysetList(state, props),
    isBulkActions: selectIsBulkActionsSubmittable(state, props),
    isSearchify: selectIsSearchifySubmittable(state, props),
    // api cache
    resourceUpdatedTimestamp: selectLastResourceUpdateTimestamp(state, props),
})

const actionCreators = {
    fetchSearchData,
    registerPermanentFilters,
    resetFilters,
    storeLastLoadedUserUpdate,
    // searchify
    toggleSearchifySelectedStatus,
}

export default connect(mapStateToProps, actionCreators)(ListView)
